// var zoomContainer =
//
// panzoom(zoomContainer)

jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.panzoom').length ) {

        let $ = jQuery;

        $(".pin-has-popup").on("click", function () {
           let $page_id = $(this).data('post_id');
           let $array_key = $(this).data('array_key');

           let $modalContainer = $(".panzoom-modal .panzoom-modal-content");

           let sendData = {
               action: 'load_panzoom_content',
               pageId: $page_id,
               arrKey: $array_key
           }

           $.ajax({
               url: ajaxadminurl.ajaxurl,
               type: 'POST',
               data: sendData,
               dataType: 'html',
               timeout: 10000,
               success: function(data, textStatus, jqXHR) {
                   var htmlData = $.parseHTML(jqXHR.responseText);
                   $(".panzoom-modal").fadeIn(750);
                   $modalContainer.html(htmlData);
               }
           });

        });

        $(".panzoom-modal .close").on("click", function () {
            $(".panzoom-modal").fadeOut();
            $(".panzoom-modal .panzoom-modal-content").empty();
        });

        let $panZoomItem = document.querySelector('.panzoom-item')

        $pz = panzoom($panZoomItem, {
            maxZoom: 3,
            minZoom: 1,
            bounds: false,
            boundsPadding: 1,
            onTouch: function(e){
                return true;
            },
            beforeMouseDown: function(e) {
                return true;
            }
        });

    }
});